import React from 'react';

import PropTypes from 'prop-types';

import BaseFeedback from '@asteria/component-feedback';

import { useTranslate } from '@asteria/language';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps> } */
const Feedback = React.memo(function Feedback(props) {
	const { onAction } = props;

	const { t } = useTranslate();

	const handleFeedbackAction = React.useCallback(
		(action, data) =>
			onAction?.('transactions:feedback:submit', {
				action: action,
				data: data,
			}),
		[onAction],
	);

	const handleFeedbackContact = React.useCallback(() => {
		onAction?.('transactions:feedback:support');
	}, [onAction]);

	return (
		<BaseFeedback
			onAction={handleFeedbackAction}
			className="asteria-component__transactions__details__sidebar__content__feedback"
			onSupportRequest={handleFeedbackContact}
			feedbackKey="transaction-details-feedback"
			description={t('transaction.details.sidebar.feedback.description')}
			minText={t('transaction.details.sidebar.feedback.min')}
			maxText={t('transaction.details.sidebar.feedback.max')}
			values={[1, 2, 3, 4, 5]}
			validate
			type="transactions"
		/>
	);
});

Feedback.propTypes = {
	onAction: PropTypes.func,
};

export default Feedback;
